import type { AppointmentStatusValue } from '@crm/shared';

/**
 * O Google Agenda colore o evento pela agenda de origem; aqui a cor vem do
 * status, que e a informacao que o salao precisa ler de relance.
 */
export const STATUS_BLOCK: Record<AppointmentStatusValue, string> = {
  SCHEDULED: 'bg-sky-600 text-white',
  CONFIRMED: 'bg-indigo-600 text-white',
  IN_PROGRESS: 'bg-amber-500 text-white',
  COMPLETED: 'bg-emerald-600 text-white',
  CANCELLED: 'bg-rose-600/80 text-white line-through',
  NO_SHOW: 'bg-muted-foreground/60 text-white line-through',
};

/**
 * Fundo da casca das visoes da agenda. Dia, semana, mes e programacao dividem
 * a mesma superficie: mudar aqui muda as quatro.
 */
export const VIEW_SURFACE = 'bg-card';

/** Bolinha usada nas visoes de mes e programacao. */
export const STATUS_DOT: Record<AppointmentStatusValue, string> = {
  SCHEDULED: 'bg-sky-600',
  CONFIRMED: 'bg-indigo-600',
  IN_PROGRESS: 'bg-amber-500',
  COMPLETED: 'bg-emerald-600',
  CANCELLED: 'bg-rose-600',
  NO_SHOW: 'bg-muted-foreground',
};
